import MicOffIcon from "@mui/icons-material/MicOff";
import { Box, Button, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";

import { ipcRendererSend, isElectron, requestMicAccess } from "@/utils";

export default function RecordingRequestHandler({ children }: { children: React.ReactNode }) {
  const [hasMicAccess, setHasMicAccess] = useState(false);

  const requestMicrophoneAccess = () => {
    ipcRendererSend("request-mic-access");
  };
  useEffect(() => {
    if (isElectron) {
      requestMicAccess()
        .then((value: boolean) => setHasMicAccess(() => value))
        .catch((value: boolean) => setHasMicAccess(() => value));
    }
  }, []);

  if (!isElectron) {
    return <>{children}</>;
  } else {
    return (
      <Box sx={{ position: "relative" }}>
        {!hasMicAccess && (
          <Tooltip title="Request Microphone Access" placement="top" arrow>
            <Button
              onClick={() => requestMicrophoneAccess()}
              sx={{
                border: "solid 2px red",
                borderRadius: "100%",
                background: "#444",
                width: "100%",
                height: "100%",
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MicOffIcon />
            </Button>
          </Tooltip>
        )}
        <>{children}</>
      </Box>
    );
  }
}
